// La Evaluación Del Trastorno Por Estrés Postraumático: Aproximación A Las Propiedades Psicométricas De La Escala De Trauma De Davidson
// Escala Trastorno Por Estrés Postraumático+608-2094-1-CE
// tabla al final de la hoja en bco ngro agregada penultima
export const post_catalog = [
    "1.He tenido alguna vez imágenes, recuerdos o pensamientos dolorosos del acontecimiento.+",
    "2.He tenido alguna vez pesadillas sobre el acontecimiento.",
    "3.He sentido que el acontecimiento estaba ocurriendo de nuevo, como si lo estuviera reviviendo ",
    "4.Hay cosas que me lo han hecho recordar.  ",
    "5.He tenido sensaciones físicas por recuerdos del acontecimiento. (Como transpiración, temblores, palpitaciones, mareos, náuseas o diarrea) ",
    "6.He estado evitando pensamientos o sentimientos sobre el acontecimiento.",
    "7.He estado evitando hacer cosas o estar en situaciones que me recordaran el acontecimiento. ",
    "8.He sido incapaz de recordar partes importantes del acontecimiento. ",
    "9.He tenido dificultad para disfrutar de las cosas. 10.Me  he sentido distante o alejado de la gente. ",
    "10.Me  he sentido distante o alejado de la gente.",
    "11.He sido incapaz de tener sentimientos de tristeza o de afecto.",
    "12.He tenido dificultad para imaginar una vida larga y cumplir mis objetivos.",
    "13.He tenido dificultad para iniciar o mantener el sueño.",
    "14.He  estado irritable o he tenido accesos de ira. ",
    "15.He tenido dificultades para concentrarme",
    "16.Me he sentido nervioso, fácilmente distraído, o como “en guardia”. ",
    "17.He estado nervioso o me he asustado fácilmente",
]